import React from 'react'

function Banner() {
  return (
    <div className='banner mission-banner'>
        <div>
            <h1 className='text-center'>Our Mission</h1>
            <p className='text-center'>EdFura is a comprehensive and trusted platform dedicated to supporting the academic and professional growth of<br/> students, researchers, and professionals in the field of Biological Sciences. </p>
        </div>
    </div>
  )
}

export default Banner